import { useEffect } from 'react';

/**
 * Clamps text until it takes lines = "toLinesCount" with support of custom clamp ending
 */
export const useClampTextToRows = (
    textRef,
    toLinesCount,
    stripWithContent = '...',
    clampTextStep = -30,
) => {
    const clampTextToLines = (el, text) => {
        // add clamp content to calculations
        el.innerHTML = `${text}${stripWithContent}`;

        // get styles of element
        const styles = getComputedStyle(el);

        const lineHeight = parseInt(styles.lineHeight.slice(0, -2));
        const elHeight = el.offsetHeight;

        // calculate amount of lines text takes
        const lines = Math.floor(elHeight / lineHeight);

        // if more than toLines - reduce text and repeat until fits
        if (lines > toLinesCount) {
            const newText = text.slice(0, clampTextStep);
            el.innerHTML = `${newText}${stripWithContent}`;
            clampTextToLines(el, newText);
        }
    };

    useEffect(() => {
        if (textRef && textRef.current) {
            const el = textRef.current;
            const text = el.innerText;

            clampTextToLines(el, text);
        }
    });
};
